import { EmbedTicketing } from "@web-app/src/components/Event/Embed/Ticketing/EmbedTicketing";
import { useRouter } from "next/router";

export default function EventPage() {
  const router = useRouter();
  const { id } = router.query;

  if (!id) return null;

  return (
    <div>
      <EmbedTicketing eventId={id as string} />
    </div>
  );
}

EventPage.getLayout = function getLayout(page: React.ReactElement) {
  return <div>{page}</div>;
};
